export const BOARD_TYPE = {
  ARRIVALS: 'ARRIVALS',
  DEPARTURES: 'DEPARTURES',
} as const;
